import React, { ReactNode } from 'react';
import { SpacingCustom } from '../../../layout/Spacing/SpacingCustom';
import { Title } from '../../../ui/Title';
import { FlexCenter } from '../../../layout/FlexCenter/FlexCenter';
import IconComponent from '../../IconComponents/IconComponent';

interface IModalContentWrapper {
    title: string;
    children?: ReactNode;
    hasIcon?: boolean;
    iconName?: string;
}

export const ModalContentWrapper: React.FC<IModalContentWrapper> = ({ title, children, hasIcon = false, iconName = 'Configure_green' }) => {
    return (
        <>
            <FlexCenter direction='v' position='start' stretch>
                {
                 hasIcon && <IconComponent size={2} iconName={iconName} />
                }
                <Title text={title} size={'l'} color='dark'/>
            </FlexCenter>
            <SpacingCustom marginTop={2}>{children}</SpacingCustom>
        </>
    );
};
